import { useState } from "react";
import algoliasearch from "algoliasearch/lite";
import { InstantSearch, Hits } from "react-instantsearch-dom";

import SearchCloseButton from "../../public/img/close.svg";
import MobileSearchButton from "../../public/img/search.svg";
import MobileCloseSearchButton from "../../public/img/chevron-right-solid.svg";
import SearchPostItem from "./items/searchPostItem";
import CustomSearchBar from "./customSearchBox";

const algoliaClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY
);
const algoliaPostsIndex = process.env.NEXT_PUBLIC_ALGOLIA_BLOG_INDEX;

type HeaderSearchBarProps = {};

export default function HeaderSearchBar({}: HeaderSearchBarProps) {
  const [showModalSearch, setShowModalSearch] = useState(false);
  const [showMobileSearchBar, setShowMobileSearchBar] = useState(false);

  return (
    // @ts-ignore
    <InstantSearch searchClient={algoliaClient} indexName={algoliaPostsIndex}>
      <div className="w-80 flex-shrink-0 hidden md:block">
        <CustomSearchBar
          setShowModalSearch={setShowModalSearch}
          showSearchImage
        />
      </div>

      <div className="md:hidden w-full flex flex-row justify-end gap-x-1 z-60">
        <div className={`flex-1 ${showMobileSearchBar ? "block" : "hidden"}`}>
          <CustomSearchBar setShowModalSearch={setShowModalSearch} />
        </div>

        <button
          className="p-2 text-gray-100"
          onClick={() => setShowMobileSearchBar(!showMobileSearchBar)}
        >
          {showMobileSearchBar ? (
            <MobileCloseSearchButton className="h-6 w-6 fill-current" />
          ) : (
            <MobileSearchButton className="h-6 w-6" />
          )}
        </button>
      </div>

      {showModalSearch && (
        <div className="fixed z-60 right-0 bottom-0 left-0 top-16">
          <div className="flex flex-row min-h-screen bg-bi-green-malachite-900 justify-center">
            <div className="pt-2 max-w-4xl w-full space-y-2">
              <div className="text-white text-2xl font-bold pl-2 flex flex-row justify-between">
                <p>Resultados</p>
                <button onClick={() => setShowModalSearch(false)}>
                  <SearchCloseButton className="w-6 h-6 transform -rotate-90 fill-current stroke-2" />
                </button>
              </div>

              <div className="posts-results-panel">
                {/* @ts-ignore */}
                <Hits
                  hitComponent={({ hit }) => (
                    <SearchPostItem
                      indexedPost={hit}
                      closeSearch={() => {
                        setShowModalSearch(false);
                        setShowMobileSearchBar(false);
                      }}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </InstantSearch>
  );
}
